export const serviceSamlRedirect = {
  production: false,
  configmaxServiceSamlRedirect: [
    {
      name: 'configmax-test-app.omnissa.com',
      url: 'https://myvmware-stg.workspaceair.com/SAAS/API/1.0/GET/apps/launch/app/4cbcfbbf-1e6a-454e-af17-f3056b1516c4'
    },
    {
      name: 'configmax-qa-app.omnissa.com',
      url: 'https://myvmware-stg.workspaceair.com/SAAS/API/1.0/GET/apps/launch/app/e9e62ddc-bde6-440c-981a-f994da421623'
    },
    {
      name: 'localhost',
      url: 'https://myvmware-stg.workspaceair.com/SAAS/API/1.0/GET/apps/launch/app/46204238-0514-4401-8a23-f7c322589865'
    },
    {
      name: 'configmax-prodstg.omnissa.com',
      url: 'https://myvmware-stg.workspaceair.com/SAAS/API/1.0/GET/apps/launch/app/8a0b3111-7996-449b-8541-32b6ec613e76'
    },
    {
      name: 'configmax.omnissa.com',
      url: 'https://myvmware.workspaceair.com/SAAS/API/1.0/GET/apps/launch/app/4005875b-dc1b-4c9f-bad3-f28a19b36f9e'
    }
  ]
};



// WEBPACK FOOTER //
// ./src/environments/serviceSamlRedirect.ts